import { autoinject } from 'aurelia-framework';
import numbro from 'numbro';

@autoinject
export class CurrencyFormatValueConverter {
	toView(value, format: string = undefined) {
		return numbro(value).format("#.00") + "€";
	}
	fromView(value) {
		return numbro.unformat(value);
	}
}
